import useCustomerInfoFormStyles from './CustomerInfoForm.styles';
import StateDropdown from '../inputs/StateDropdown';
import DobInput from '../inputs/DobInput';
import { useCart } from '../../../contexts/CartContext/CartContext.hooks';
import BaseInputField from '../inputs/BaseInputField/BaseInputField';
import { useEffect, useState } from 'react';

const CustomerInfoForm = () => {
    const styles = useCustomerInfoFormStyles();
    const { cart, updateCustomerInfo } = useCart();

    const [firstName, setFirstName] = useState(cart.customerInfo.firstName);
    const [lastName, setLastName] = useState(cart.customerInfo.lastName);
    const [addressLine1, setAddressLine1] = useState(cart.customerInfo.address.addressLine1);
    const [addressLine2, setAddressLine2] = useState(cart.customerInfo.address.addressLine2);
    const [city, setCity] = useState(cart.customerInfo.address.city);
    const [state, setState] = useState(cart.customerInfo.address.state);
    const [zipcode, setZipcode] = useState(cart.customerInfo.address.zipcode);
    const [phoneNumber, setPhoneNumber] = useState(cart.customerInfo.phoneNumber);
    const [emailAddress, setEmailAddress] = useState(cart.customerInfo.emailAddress);
    const [dob, setDob] = useState(cart.customerInfo.dob);
    const [employer, setEmployer] = useState(cart.customerInfo.employer);
    const [driversLicenseNumber, setDriversLicenseNumber] = useState(
        cart.customerInfo.driversLicenseNumber
    );
    const [driversLicenseState, setDriversLicenseState] = useState(
        cart.customerInfo.driversLicenseState
    );

    useEffect(() => {
        updateCustomerInfo({
            ...cart.customerInfo,
            driversLicenseNumber,
            driversLicenseState,
            firstName,
            lastName,
            address: {
                addressLine1,
                addressLine2,
                city,
                state,
                zipcode
            },
            phoneNumber,
            emailAddress,
            dob,
            employer
        });
    }, [
        driversLicenseNumber,
        driversLicenseState,
        firstName,
        lastName,
        addressLine1,
        addressLine2,
        city,
        state,
        zipcode,
        phoneNumber,
        emailAddress,
        dob,
        employer
    ]);

    return (
        <form name={'customerInfoForm'} className={styles.root}>
            <div className={styles.inquiryContactInfo}>
                <BaseInputField
                    name='firstName'
                    label='First Name'
                    className={styles.firstNameContainer}
                    required
                    defaultValue={firstName}
                    onChange={setFirstName}
                />

                <BaseInputField
                    name='lastName'
                    label='Last Name'
                    className={styles.lastNameContainer}
                    required
                    defaultValue={lastName}
                    onChange={setLastName}
                />

                <BaseInputField
                    name='addressLine1'
                    label='Address Line 1'
                    className={styles.address1Container}
                    required
                    defaultValue={addressLine1}
                    onChange={setAddressLine1}
                />

                <BaseInputField
                    name='addressLine2'
                    label='Address Line 2'
                    className={styles.address2Container}
                    defaultValue={addressLine2}
                    onChange={setAddressLine2}
                />

                <BaseInputField
                    name='city'
                    label='City'
                    className={styles.cityContainer}
                    required
                    defaultValue={city}
                    onChange={setCity}
                />

                <StateDropdown
                    className={styles.stateContainer}
                    required
                    showOnlyValidMarkets={true}
                    value={state}
                    onChange={setState}
                />

                <BaseInputField
                    name='zipcode'
                    label='Zipcode'
                    className={styles.zipcodeContainer}
                    required
                    defaultValue={zipcode}
                    onChange={setZipcode}
                />

                <BaseInputField
                    name='phoneNumber'
                    label='Phone Number'
                    className={styles.phoneNumberContainer}
                    required
                    defaultValue={phoneNumber}
                    onChange={setPhoneNumber}
                />

                <BaseInputField
                    name='emailAddress'
                    label='Email Address'
                    className={styles.emailContainer}
                    required
                    defaultValue={emailAddress}
                    onChange={setEmailAddress}
                />

                <DobInput value={dob} className={styles.dobContainer} required onChange={setDob} />

                <BaseInputField
                    className={styles.employerContainer}
                    name='employer'
                    label='Employer'
                    required
                    defaultValue={employer}
                    onChange={setEmployer}
                />

                <BaseInputField
                    className={styles.driversLicenseNumber}
                    name='driversLicenseNumber'
                    label='Drivers License Number'
                    required
                    defaultValue={driversLicenseNumber}
                    onChange={setDriversLicenseNumber}
                />

                <StateDropdown
                    className={styles.driversLicenseState}
                    label={'Drivers License State'}
                    required
                    showOnlyValidMarkets={false}
                    value={driversLicenseState}
                    onChange={setDriversLicenseState}
                />
            </div>
        </form>
    );
};

export default CustomerInfoForm;
